/* eslint-disable camelcase */

export default class DtoPgsseDiagnosticWithActions {
    constructor(obj) {
        this.idDiag = obj.idDiag // Option[Long],
        this.idContributor = obj.idContributor // Option[Long],
        this.idSector = obj.idSector // Option[Long],
        this.idUdi = obj.idUdi // Option[Long],
        this.year = obj.year // Option[Int],
        this.nbCreation = obj.nbCreation // Option[Int],
        this.nbUpdate = obj.nbUpdate // Option[Int],
        this.nbResolved = obj.nbResolved // Option[Int],
    }
}
